
import React from 'react';
import { AlertTriangle } from 'lucide-react';

export const BikeMaintenanceWarning: React.FC = () => {
  return (
    <div className="bg-amber-50 dark:bg-amber-950/30 p-3 rounded-md flex items-center gap-2 text-amber-600 dark:text-amber-400">
      <AlertTriangle className="h-5 w-5" />
      <p className="text-sm">Велосипед находится на техническом обслуживании</p>
    </div>
  );
};
